import { Espece } from "@repo/types";

export const formatSpecies = (espece: Espece) => {
  if (!espece) return '';
  let toReturn = espece.genre || '';
  // Name is "espece"
  if (espece.name) {
    toReturn = `${toReturn} ${espece.name}`;
  }
  if (espece.cultivar) {
    toReturn = `${toReturn} ${espece.cultivar}`;
  }

  return toReturn;
};
